import styled from 'styled-components';

export const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 1100px;
	margin-left: 10px;
	overflow: hidden;
`;
export const StyledTourRow = styled.div`
	display: flex;
	align-items: center;
	width: 100%;
	height: 85px;
	margin-bottom: 5px;
	.activity_content {
		display: flex;
		height: 100%;
		width: 100%;
		span {
			width: 100%;
			height: 100%;
		}
	}
`;
